import React, {useEffect} from 'react';

import classNames from 'classnames';

import {Spinner} from './../spinner';
import {INotificationProps, Notification} from './../notification';
import {Button, IButtonProps} from '../button';

export interface IMainProps {
    children: React.ReactNode;
    isLoading?: boolean;
    notifications?: INotificationProps[];
    showBackground?: boolean;
    mobileBackButton?: IButtonProps
    mobileForwardButton?: IButtonProps
}

const Main = (props: IMainProps): JSX.Element => {
    const setAppHeight: () => void = (): void => {
        document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
    };

    useEffect(() => {
        setAppHeight();
        window.addEventListener('resize', setAppHeight);

        return (): void => {
            window.removeEventListener('resize', setAppHeight);
        };
    }, []);

    const renderBackgroundImage = (modifier: string): JSX.Element => {
        const backgroundClasses: string = classNames(
            'main__background-image',
            [`main__background-image--${modifier}`],
        );

        return (
            <div className={backgroundClasses}>
                <div className="main__image" />
            </div>
        );
    };

    const className: string = classNames(
        'main',
        {
            'is-loading': props.isLoading,
        },
    );

    return (
        <div className={className}>
            {props.mobileBackButton && <Button {...props.mobileBackButton} type={'button'} icon={'arrow-left'} color={'white'} className="main__button" />}
            {props.mobileForwardButton && <Button {...props.mobileForwardButton} type={'button'} icon={'arrow-right'} color={'white'} className="main__button" />}
            {props.notifications && props.notifications.map((el: INotificationProps, i: number) => <Notification {...el} className="main__notification" key={i} />)}
            {props.children}
            <div className="main__overlay">
                <Spinner />
            </div>
            {props.showBackground &&
                <div className="main__background">
                    {renderBackgroundImage('green')}
                    {renderBackgroundImage('yellow')}
                    {renderBackgroundImage('red')}
                </div>
            }
        </div>
    );
};

export default Main;
